import { getCRRatioColor } from '../utils/format';

interface StatsSummaryCardsProps {
  totalCosts: number;
  totalRevenue: number;
  costOverRevenue: number;
}

export default function StatsSummaryCards({ totalCosts, totalRevenue, costOverRevenue }: StatsSummaryCardsProps) {
  return (
    <div className="grid grid-cols-3 gap-4">
      {/* Total Costs */}
      <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-primary-500/10 to-primary-600/5 dark:from-primary-500/20 dark:to-primary-600/10 border border-primary-200/50 dark:border-primary-500/30 p-4">
        <div className="absolute top-0 right-0 w-16 h-16 -mr-4 -mt-4 bg-primary-500/10 rounded-full flex items-center justify-center">
          <svg className="w-6 h-6 text-primary-500 mt-3 -ml-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <span className="text-xs font-medium text-primary-600 dark:text-primary-400 uppercase tracking-wide">Total Costs</span>
        <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">
          {totalCosts.toLocaleString('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 })}
        </p>
      </div>

      {/* Total Revenue */}
      <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-accent-aquamarine/10 to-accent-turquoise/5 dark:from-accent-aquamarine/20 dark:to-accent-turquoise/10 border border-accent-aquamarine/30 dark:border-accent-aquamarine/30 p-4">
        <div className="absolute top-0 right-0 w-16 h-16 -mr-4 -mt-4 bg-accent-aquamarine/10 rounded-full flex items-center justify-center">
          <svg className="w-6 h-6 text-accent-aquamarine mt-3 -ml-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
          </svg>
        </div>
        <span className="text-xs font-medium text-accent-turquoise uppercase tracking-wide">Total Revenue</span>
        <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">
          {totalRevenue.toLocaleString('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 })}
        </p>
      </div>

      {/* C/R Ratio */}
      <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-accent-blue/10 to-accent-blue/5 dark:from-accent-blue/20 dark:to-accent-blue/10 border border-accent-blue/30 p-4">
        <div className="absolute top-0 right-0 w-16 h-16 -mr-4 -mt-4 bg-accent-blue/10 rounded-full flex items-center justify-center">
          <svg className="w-6 h-6 text-accent-blue mt-3 -ml-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
        <span className="text-xs font-medium text-accent-blue uppercase tracking-wide">C/R Ratio</span>
        <p className="text-2xl font-bold mt-1" style={{ color: getCRRatioColor(costOverRevenue) }}>
          {costOverRevenue.toFixed(2)}
        </p>
      </div>
    </div>
  );
}
